module.exports = __webpack_public_path__ + "img/fi.5a5d8689.svg";